import React, { useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { message as toaster } from 'antd';
import { orderBy } from 'lodash';
import moment from 'moment';
import {
	CollectionHeader,
	InvoiceFormAmortization,
	RejectionDetailsCard,
} from 'components/pages/collection';
import { Flex, Text } from 'atoms';
import { theme } from 'styles/theme';
import { useQueryParams } from 'hooks';
import { Rupee } from 'components';
import {
	setFilteredInvoices,
	setFilteredReceivedInvoices,
	setFilteredDelegateInvoices,
	setSalesMenSearch,
	getAlreadyPaidUPIList,
	getDeliveryDate,
} from 'store/invoiceSlice';

const Container = styled(Flex)`
	flex-direction: column;
	background-color: ${(props) => props.theme.colors.white};
`;

export default function StorePayment() {
	const {
		filteredInvoices = [],
		filteredReceivedInvoices = [],
		invoices = [],
		receivedInvoiceList = [],
		delegationInvoiceList = [],
	} = useSelector((state) => state.invoice);
	const { me = {} } = useSelector((state) => state.user);

	const [isEditMode, setIsEditMode] = useState(false);
	const [previousUPIPayments, setPreviousUPIPayments] = useState();
	const { storeId } = useQueryParams();
	const history = useHistory();
	const dispatch = useDispatch();
	const { salesmanId = undefined } = useQueryParams();

	function resetFilter() {
		/**
		 * on page load and unload reset the filters
		 */
		dispatch(setFilteredInvoices(invoices));
		dispatch(setFilteredReceivedInvoices(receivedInvoiceList));
		dispatch(setFilteredDelegateInvoices(delegationInvoiceList));
		dispatch(setSalesMenSearch(''));
	}

	const [showgetDelDetails, SetshowgetDelDetails] = useState({});

	useEffect(() => {
		dispatch(getDeliveryDate()).then((res) => {
			console.log(res);
			SetshowgetDelDetails(res);
		});
	}, [dispatch]);
	console.log(showgetDelDetails);

	useEffect(() => {
		dispatch(
			getAlreadyPaidUPIList({
				salesmanId: salesmanId || me?.id,
				store_id: storeId,
			})
		).then((res) => {
			setPreviousUPIPayments(res?.data);
		});
	}, [dispatch, me, salesmanId, storeId]);

	useEffect(() => {
		resetFilter();

		return () => {
			resetFilter();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const sameStore = useMemo(() => {
		/**
		 * First time it will check the Fresh bills
		 */
		/**
		 * For my invoices
		 */
		let list = filteredInvoices?.filter(
			(item) => item?.store_id === Number(storeId) && item?.status === 'Pending'
		);

		/**
		 * For received invoices
		 */
		let receivedList = filteredReceivedInvoices?.filter(
			(item) => item?.store_id === Number(storeId) && item?.status === 'Pending'
		);

		if (list?.length === 0 && receivedList?.length === 0) {
			/**
			 * If not fresh bills are available check the BB, NBB bills for edit mode
			 */
			list = filteredInvoices?.filter(
				(item) => item?.store_id === Number(storeId) && item?.status !== 'Pending'
			);
			receivedList = filteredReceivedInvoices?.filter(
				(item) => item?.store_id === Number(storeId) && item?.status !== 'Pending'
			);
			setIsEditMode(true);
		}

		let sortedInvoices = [...list, ...receivedList];

		sortedInvoices = orderBy(
			sortedInvoices,
			(o) => moment(o.invoice_date).format('YYYY-MM-DD hh:mm:ss'),
			['asc']
		);

		return sortedInvoices;
	}, [filteredInvoices, filteredReceivedInvoices, storeId]);

	const totalOutstanding = sameStore?.reduce(
		(acc, curr) => acc + Number(curr?.initial_outstanding_amount) || 0,
		0
	);

	if (sameStore?.length === 0) {
		history.push('/collection');
		toaster.error('Invoices not available, redirecting to collection page');
	}

	return (
		<Container>
			<CollectionHeader />
			<Text
				textAlign="center"
				color={theme.colors.primary}
				fontSize="10px"
				mt="10px"
				textTransform="capitalize"
			>
				{sameStore?.[0]?.store_name}
			</Text>
			<Flex my="10px" justifyContent="center">
				<Text textAlign="center" fontSize="10px" mx="5px">
					Total Invoice:{' '}
					<Text as="span" fontWeight="bold">
						{sameStore?.length}
					</Text>
				</Text>
				<Text textAlign="center" fontSize="10px" mx="5px">
					Total Outstanding Value:{' '}
					<Text as="span" fontWeight="bold">
						<Rupee>{totalOutstanding}</Rupee>
					</Text>
				</Text>
			</Flex>
			<RejectionDetailsCard
				invoices={sameStore?.filter((item) => item?.rejectNotification?.length)}
			/>
			<InvoiceFormAmortization
				isEditMode={isEditMode}
				storeInvoices={sameStore}
				totalOutstanding={totalOutstanding}
				previousUPIPayments={previousUPIPayments}
				deliveryDate={showgetDelDetails}
			/>
		</Container>
	);
}
